import type { RouteLocationNormalizedLoaded } from "vue-router"

// Table de correspondance label -> icône (doit correspondre à AppMenu.vue)
const breadcrumbIcons: Record<string, string> = {
  Accueil: "pi pi-home",
  Fonds: "pi pi-briefcase",
  "Philosophie de gestion": "pi pi-compass",
  "Pôles d'investissement": "pi pi-sitemap",
  "Finance durable": "pi pi-globe",
  "Nous connaître": "pi pi-users",
  "Lettres d'investissement": "pi pi-envelope",
  Arago: "pi pi-star",
  Contacts: "pi pi-phone",
}

export function breadcrumbFromRoute(route: RouteLocationNormalizedLoaded) {
  if (route.meta.breadcrumb) {
    return Array.isArray(route.meta.breadcrumb)
      ? route.meta.breadcrumb.map((label: string) => ({
          label,
          to: undefined,
          icon: breadcrumbIcons[label] || undefined,
        }))
      : []
  }
  const segments = route.fullPath
    .split("/")
    .filter((item) => item !== "")
    .filter((item) => isNaN(Number(item)))
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
  return segments.map((label) => ({
    label,
    to: undefined,
    icon: breadcrumbIcons[label] || undefined,
  }))
}
